// Strongs Konkordanz - Deutsche Übersetzungen
// Strong's Dictionary - German Translations

export const strongTranslationsDE = {
  "G25": {
    m: "mit göttlicher und bedingungsloser Liebe lieben",
    d: "Mit selbstloser, opferbereiter und göttlicher Liebe lieben. Dies ist die Liebe Gottes zur Menschheit und die Liebe, die wir einander entgegenbringen sollen.",
    u: "143-mal im NT verwendet. Beschreibt die göttliche, vollkommene und bedingungslose Liebe.",
    e: "Von ἄγω (ago) = führen, zum Guten leiten"
  },
  "G26": {
    m: "göttliche Liebe, Nächstenliebe",
    d: "Die vollkommene Liebe Gottes; brüderliche Liebe, Zuneigung, Wohlwollen, Nächstenliebe. Die Liebe, die Gott und den Menschen sowie Menschen untereinander verbindet.",
    u: "116-mal im NT verwendet. Das zentrale Wort des Christentums für göttliche Liebe.",
    e: "Abgeleitet von ἀγαπάω (agapao)"
  },
  "G4102": {
    m: "Glaube, Vertrauen, Treue",
    d: "Überzeugung von der Wahrheit; im NT eine Überzeugung bezüglich der Beziehung des Menschen zu Gott und göttlichen Dingen.",
    u: "244-mal im NT verwendet. Zentrales Konzept des christlichen Glaubens.",
    e: "Von πείθω (peitho) = überzeugen, überreden"
  },
  "G1680": {
    m: "Hoffnung, zuversichtliche Erwartung",
    d: "Erwartung guter Dinge, auf Gott gegründete Hoffnung; Vertrauen in die Zukunft basierend auf göttlichen Verheißungen.",
    u: "54-mal im NT verwendet. Eine der drei theologischen Tugenden zusammen mit Glaube und Liebe.",
    e: "Von ἔλπω (elpo) = erwarten, hoffen"
  },
  "G5281": {
    m: "Geduld, Ausdauer, Beharrlichkeit",
    d: "Eigenschaft dessen, der den Umständen oder Druck nicht nachgibt; geduldiges Ausharren, Beständigkeit.",
    u: "32-mal im NT verwendet. Wesentliche christliche Tugend.",
    e: "Von ὑπό (hupo) = unter und μένω (meno) = bleiben"
  },
  "G5544": {
    m: "Güte, Freundlichkeit",
    d: "Güte in der Tat, praktische Freundlichkeit; Eigenschaft dessen, der anderen nützlich und hilfreich ist.",
    u: "10-mal im NT verwendet. Frucht des Geistes nach Galater 5:22.",
    e: "Von χρηστός (chrestos) = gut, nützlich, freundlich"
  },
  "G2205": {
    m: "Eifer, Eifersucht, Neid",
    d: "Leidenschaftliche Glut; kann positiv sein (Eifer für Gott) oder negativ (Eifersucht, Neid).",
    u: "16-mal im NT verwendet. Je nach Kontext tugendhaft oder lasterhaft.",
    e: "Von ζέω (zeo) = kochen, eifrig sein"
  },
  "G166": {
    m: "ewig, immerwährend",
    d: "Ohne Anfang und Ende, immer existierend; im NT oft verbunden mit dem ewigen Leben in Gott.",
    u: "71-mal im NT verwendet. Qualifiziert oft das ewige Leben und Gottes Reich.",
    e: "Von αἰών (aion) = Zeitalter, Epoche, Ewigkeit"
  },
  "G2316": {
    m: "Gott, Gottheit",
    d: "Das höchste Wesen, Gott der Vater, Jesus Christus, der Heilige Geist; manchmal für falsche Götter verwendet.",
    u: "1317-mal im NT verwendet. Das zentrale Wort für Gott.",
    e: "Ursprung unsicher, möglicherweise von θέω (theo) = laufen, oder τίθημι (tithemi) = setzen"
  },
  "G1097": {
    m: "erkennen, wissen, verstehen",
    d: "Durch persönliche Erfahrung erkennen; verstehen, wahrnehmen, sich bewusst sein.",
    u: "222-mal im NT verwendet. Erfahrungsmäßiges Wissen, nicht nur intellektuell.",
    e: "Indoeuropäische Wurzel *gen- = erzeugen, erkennen"
  },
  "G2889": {
    m: "Welt, Universum, Menschheit",
    d: "Die Ordnung der Welt, das Universum; die gefallene Menschheit; das System im Gegensatz zu Gott.",
    u: "186-mal im NT verwendet. Kann die Schöpfung oder das sündige System bezeichnen.",
    e: "Von κοσμέω (kosmeo) = schmücken, ordnen"
  },
  "G5207": {
    m: "Sohn",
    d: "Männlicher Nachkomme; Jünger; Mitglied einer Gruppe. Der Sohn Gottes = Jesus Christus.",
    u: "377-mal im NT verwendet. Oft zur Bezeichnung Jesu als Sohn Gottes.",
    e: "Ursprung unsicher, möglicherweise verwandt mit ὕω (huo) = regnen lassen, erzeugen"
  },
  "G4151": {
    m: "Geist, Atem, Wind",
    d: "Der Lebenshauch, das Lebensprinzip; die vernünftige Seele; der Heilige Geist.",
    u: "385-mal im NT verwendet. Bezeichnet den Heiligen Geist, den menschlichen Geist oder Geister.",
    e: "Von πνέω (pneo) = blasen, atmen"
  },
  "G225": {
    m: "Wahrheit, Wirklichkeit",
    d: "Was in Bezug auf Gott und die Pflichten des Menschen wahr ist; die geoffenbarte göttliche Wahrheit.",
    u: "109-mal im NT verwendet. Zentrales Konzept der Lehre Jesu.",
    e: "Von ἀληθής (alethes) = wahr, aufrichtig"
  },
  "G93": {
    m: "Ungerechtigkeit, Unrecht",
    d: "Verletzung des Rechts, Ungerechtigkeit; Bosheit, moralisches Unrecht.",
    u: "25-mal im NT verwendet. Gegenteil von δικαιοσύνη (Gerechtigkeit).",
    e: "Von ἀ- (negativ) + δίκη (dike) = Gerechtigkeit"
  },
  "G5463": {
    m: "sich freuen, froh sein",
    d: "Sich freuen, glücklich sein; Gruß 'freue dich' oder 'sei gegrüßt'.",
    u: "74-mal im NT verwendet. Häufige Aufforderung, sich in Christus zu freuen.",
    e: "Verwandt mit χάρις (charis) = Gnade"
  },
  "G4648": {
    m: "aufmerksam betrachten, anvisieren",
    d: "Die Augen fixieren auf, sorgfältig betrachten; ein Ziel haben, anvisieren.",
    u: "6-mal im NT verwendet. Aufruf, die Augen auf Christus zu richten.",
    e: "Verwandt mit σκοπός (skopos) = Ziel"
  },
  "G2596": {
    m: "gemäß, gegen, durch",
    d: "Präposition mit mehreren Bedeutungen: gemäß, entsprechend; gegen; durch.",
    u: "Über 470-mal im NT verwendet. Sehr häufige Präposition.",
    e: "Primäre Präposition"
  },
  "G3609": {
    m: "häuslich, zum Haus gehörend",
    d: "Zum Haus gehörend, Familienmitglied; Hausdiener.",
    u: "3-mal im NT verwendet. Beschreibt Mitglieder der Familie Gottes.",
    e: "Von οἶκος (oikos) = Haus"
  },
  "G1325": {
    m: "geben, gewähren",
    d: "Jemandem etwas geben; gewähren, erlauben; übergeben.",
    u: "415-mal im NT verwendet. Gott gibt großzügig.",
    e: "Primäre Wurzel"
  },
  "G1785": {
    m: "Gebot, Befehl",
    d: "Ein Befehl, Gebot, Vorschrift; besonders ein göttliches Gebot.",
    u: "67-mal im NT verwendet. Die Gebote Gottes und Christi.",
    e: "Von ἐντέλλομαι (entellomai) = befehlen"
  },
  "G2537": {
    m: "neu, kürzlich",
    d: "Neu in Zeit oder Qualität; frisch, kürzlich, ungebraucht.",
    u: "42-mal im NT verwendet. Neue Schöpfung, neues Gebot.",
    e: "Wurzel unsicher"
  },
  "G3101": {
    m: "Jünger, Schüler",
    d: "Ein Lernender, Student, Jünger; Nachfolger Jesu.",
    u: "261-mal im NT verwendet. Bezeichnet die Nachfolger Christi.",
    e: "Von μανθάνω (manthano) = lernen"
  },
  "G2588": {
    m: "Herz",
    d: "Das physische Herz; das Zentrum des inneren Lebens, die Seele, der Geist; Gedanken und Gefühle.",
    u: "156-mal im NT verwendet. Sitz des geistlichen Lebens.",
    e: "Primäre Wurzel"
  },
  "G5590": {
    m: "Seele, Leben",
    d: "Der Lebenshauch, die vitale Seele; das Leben selbst; die unsterbliche Seele.",
    u: "105-mal im NT verwendet. Das geistliche und ewige Leben.",
    e: "Von ψύχω (psucho) = atmen, erfrischen"
  },
  "G1271": {
    m: "Verstand, Denken",
    d: "Die Fähigkeit zu denken, zu hören, zu verstehen; der Verstand, das Verständnis.",
    u: "12-mal im NT verwendet. Der durch Christus erneuerte Verstand.",
    e: "Von διά (dia) = durch + νοῦς (nous) = Verstand"
  },
  "G4413": {
    m: "erster, wichtigster",
    d: "Der erste in Zeit, Ort, Reihenfolge oder Bedeutung.",
    u: "155-mal im NT verwendet. Das erste Gebot, der erste Platz.",
    e: "Superlativ von πρό (pro) = vor"
  },
  "G3173": {
    m: "groß, wichtig",
    d: "Groß an Größe, Menge oder Bedeutung; mächtig, wunderbar.",
    u: "243-mal im NT verwendet. Die Größe Gottes.",
    e: "Primäre Wurzel"
  },
  "G1208": {
    m: "zweiter",
    d: "Der zweite in einer Reihe oder Ordnung.",
    u: "44-mal im NT verwendet. Das zweite Gebot.",
    e: "Von δύο (duo) = zwei"
  },
  "G3664": {
    m: "ähnlich, gleich",
    d: "Ähnlich, von gleicher Natur oder Charakter; gleichwertig.",
    u: "45-mal im NT verwendet. Das zweite Gebot ist dem ersten gleich.",
    e: "Von ὁμός (homos) = gleich"
  },
  "G4139": {
    m: "Nächster, Nachbar",
    d: "Derjenige, der nahe ist, der Nachbar; der Nächste im Allgemeinen.",
    u: "17-mal im NT verwendet. 'Liebe deinen Nächsten wie dich selbst'.",
    e: "Adverb wurde zum Substantiv, von πλησίος (plesios) = nahe"
  },
  "G1473": {
    m: "ich",
    d: "Personalpronomen der ersten Person Singular.",
    u: "2567-mal im NT verwendet. Sehr häufig.",
    e: "Primäres Pronomen"
  },
  "G3962": {
    m: "Vater",
    d: "Ein natürlicher oder geistlicher Vater; Vorfahre; Gott der Vater.",
    u: "413-mal im NT verwendet. Oft zur Bezeichnung Gottes.",
    e: "Primäre Wurzel, verwandt mit lateinisch 'pater'"
  },
  "G1520": {
    m: "ein, einzig",
    d: "Nur einer; einzig, allein; ein gewisser.",
    u: "344-mal im NT verwendet. Die Einheit Gottes, die vereinte Kirche.",
    e: "Primäre Wurzel"
  },
  "G3708": {
    m: "sehen, schauen",
    d: "Mit den Augen sehen; wahrnehmen, verstehen; erscheinen.",
    u: "454-mal im NT verwendet. Christus sehen, den Vater sehen.",
    e: "Primäre Wurzel"
  },
  "G1166": {
    m: "zeigen, beweisen",
    d: "Vor Augen stellen, zeigen; beweisen, demonstrieren.",
    u: "33-mal im NT verwendet. Gott zeigt seine Herrlichkeit.",
    e: "Primäre Wurzel"
  },
  "G281": {
    m: "Amen, wahrlich",
    d: "Bestätigungsformel: so sei es, wahrlich, gewiss.",
    u: "129-mal im NT verwendet. Jesus sagt 'Wahrlich, wahrlich'.",
    e: "Vom hebräischen אָמֵן (amen) = fest, treu"
  },
  "G1510": {
    m: "sein, existieren",
    d: "Das Verb sein in all seinen Bedeutungen; existieren, bleiben, geschehen.",
    u: "Das am häufigsten verwendete Verb im NT (2460+ mal).",
    e: "Primäre Wurzel"
  },
  "G11": {
    m: "Abraham",
    d: "Der Patriarch Abraham, Vater der Gläubigen.",
    u: "73-mal im NT verwendet. Vorbild des Glaubens.",
    e: "Vom hebräischen אַבְרָהָם (Abraham) = Vater einer Menge"
  },
  "G3598": {
    m: "Weg, Pfad",
    d: "Straße, Weg; Lebensweise, Verhalten; der Weg des Heils.",
    u: "101-mal im NT verwendet. Jesus ist der Weg.",
    e: "Primäre Wurzel"
  },
  "G4166": {
    m: "Hirte, Pastor",
    d: "Derjenige, der Schafe hütet; geistlicher Wächter, Gemeindepastor.",
    u: "18-mal im NT verwendet. Jesus der gute Hirte.",
    e: "Von ποίμνη (poimne) = Herde"
  },
  "G2570": {
    m: "gut, schön",
    d: "Gut in seiner Natur, schön; ehrenhaft, ausgezeichnet, tugendhaft.",
    u: "100-mal im NT verwendet. Der gute Hirte, die guten Werke.",
    e: "Primäre Wurzel"
  },
  "G5087": {
    m: "legen, setzen, bestimmen",
    d: "Legen, platzieren; einsetzen, ernennen; niederlegen, setzen.",
    u: "100-mal im NT verwendet. Sein Leben für die Schafe hingeben.",
    e: "Primäre Wurzel"
  },
  "G4263": {
    m: "Schaf",
    d: "Schaf; metaphorisch die Jünger Christi.",
    u: "39-mal im NT verwendet. Die Gläubigen als Schafe des Hirten.",
    e: "Wahrscheinlich verwandt mit προβαίνω (probaino) = vorwärtsgehen"
  },
  "G740": {
    m: "Brot",
    d: "Brot, Nahrung; das Brot des Lebens = Christus.",
    u: "97-mal im NT verwendet. Jesus das Brot des Lebens.",
    e: "Von ἄρω (aro) = erheben, aufheben"
  },
  "G3756": {
    m: "nicht, nein",
    d: "Absolute Verneinung, nein, nicht.",
    u: "Über 1600-mal im NT verwendet. Sehr häufiges Verneinungspartikel.",
    e: "Primäres Verneinungspartikel"
  },
  "G1372": {
    m: "dürsten, sich sehnen",
    d: "An Durst leiden; sich sehnen, verlangen nach.",
    u: "16-mal im NT verwendet. Geistlicher Durst nach Gott.",
    e: "Von δίψα (dipsa) = Durst"
  },
  "G1411": {
    m: "Kraft, Macht, Wunder",
    d: "Kraft, Macht, Fähigkeit; mächtige Tat, Wunder.",
    u: "120-mal im NT verwendet. Die Kraft Gottes, des Heiligen Geistes.",
    e: "Von δύναμαι (dunamai) = können"
  },
  "G1743": {
    m: "stärken, kräftigen",
    d: "Stark machen, stärken; Kraft geben.",
    u: "8-mal im NT verwendet. Gott stärkt die Gläubigen.",
    e: "Von ἐν (en) = in + δυναμόω (dynamoo) = mächtig machen"
  },
  "G1515": {
    m: "Friede",
    d: "Zustand der Ruhe; Friede mit Gott; Harmonie zwischen Menschen.",
    u: "92-mal im NT verwendet. Der Friede Christi.",
    e: "Von εἴρω (eiro) = verbinden, zusammenfügen"
  },
  "G5432": {
    m: "bewahren, schützen",
    d: "Durch eine militärische Wache bewahren; schützen, erhalten.",
    u: "4-mal im NT verwendet. Der Friede Gottes bewahrt unsere Herzen.",
    e: "Von φρουρός (phrouros) = Wache, Wächter"
  },
  "G5457": {
    m: "Licht",
    d: "Physisches oder geistliches Licht; die geoffenbarte göttliche Wahrheit.",
    u: "73-mal im NT verwendet. Jesus Licht der Welt.",
    e: "Von φάω (phao) = scheinen"
  },
  "G27": {
    m: "geliebt, teuer",
    d: "Geliebt, geschätzt; von Gott oder Menschen geliebt.",
    u: "61-mal im NT verwendet. Der geliebte Sohn Gottes.",
    e: "Von ἀγαπάω (agapao) = lieben"
  },
  "G1080": {
    m: "zeugen, gebären",
    d: "Zeugen, zur Geburt bringen; geistlich wiedergeboren werden.",
    u: "97-mal im NT verwendet. Von Gott geboren, wiedergeboren werden.",
    e: "Primäre Wurzel"
  },
  "G3474": {
    m: "Torheit, Dummheit",
    d: "Torheit, Absurdität; was an Weisheit mangelt.",
    u: "5-mal im NT verwendet. Gottes Weisheit erscheint der Welt als Torheit.",
    e: "Von μωρός (moros) = töricht, unverständig"
  },
  "G4680": {
    m: "weise, gelehrt",
    d: "Weise, intelligent, geschickt; gebildet, gelehrt.",
    u: "22-mal im NT verwendet. Die wahre Weisheit kommt von Gott.",
    e: "Primäre Wurzel"
  },
  "G444": {
    m: "Mensch, menschliches Wesen",
    d: "Menschliches Wesen, Mann oder Frau; die Menschheit im Allgemeinen.",
    u: "550-mal im NT verwendet. Der Mensch, geschaffen nach dem Bild Gottes.",
    e: "Von ἀνήρ (aner) = Mann und ὤψ (ops) = Gesicht"
  },
  "G772": {
    m: "schwach, krank",
    d: "Ohne Kraft, schwach; krank, gebrechlich; geistlich schwach.",
    u: "25-mal im NT verwendet. Gott wählt die Schwachen der Welt.",
    e: "Von ἀ- (negativ) + σθένος (sthenos) = Kraft"
  },
  "G1586": {
    m: "auswählen, erwählen",
    d: "Für sich auswählen, aussuchen; durch göttliche Gnade erwählt werden.",
    u: "21-mal im NT verwendet. Gott erwählt seine Kinder.",
    e: "Von ἐκ (ek) = aus + λέγω (lego) = auswählen"
  },
  "G2617": {
    m: "beschämen, entehren",
    d: "Beschämen, entehren; verwirren, demütigen.",
    u: "13-mal im NT verwendet. Gott verwirrt die Weisen der Welt.",
    e: "Von κατά (kata) = gegen + αἰσχύνω (aischuno) = sich schämen"
  },
  "G36": {
    m: "von niedriger Geburt, unedel",
    d: "Ohne Adel, von niedriger Herkunft; verachtet.",
    u: "1-mal im NT verwendet (1Kor 1:28).",
    e: "Von ἀ- (negativ) + γένος (genos) = Geburt"
  },
  "G1848": {
    m: "verachten, gering schätzen",
    d: "Als nichts betrachten, verachten; mit Verachtung behandeln.",
    u: "11-mal im NT verwendet. Die Welt verachtet, was Gott erwählt.",
    e: "Von ἐξ (ex) = aus + οὐθείς (outheis) = niemand"
  },
  "G4561": {
    m: "Fleisch, Körper",
    d: "Fleisch, Fleisch; der menschliche Körper; die gefallene menschliche Natur.",
    u: "147-mal im NT verwendet. Kontrast zwischen Fleisch und Geist.",
    e: "Primäre Wurzel"
  },
  "G2744": {
    m: "sich rühmen, prahlen",
    d: "Sich rühmen, prahlen; seinen Stolz in etwas finden.",
    u: "37-mal im NT verwendet. Sich im Herrn rühmen.",
    e: "Von καῦχος (kauchos) = Prahlerei"
  },
  "G5040": {
    m: "kleines Kind",
    d: "Kleines Kind, Säugling; liebevoller Begriff für Jünger.",
    u: "8-mal im NT verwendet. Johannes nennt seine Leser 'kleine Kinder'.",
    e: "Verkleinerungsform von τέκνον (teknon) = Kind"
  },
  "G3056": {
    m: "Wort, Rede, Vernunft",
    d: "Gesprochenes Wort; Vernunft, Intelligenz; der Logos = Christus.",
    u: "330-mal im NT verwendet. Der fleischgewordene Logos.",
    e: "Von λέγω (lego) = sagen"
  },
  "G1100": {
    m: "Zunge, Sprache",
    d: "Sprachorgan; Sprache, Dialekt; Gabe der Zungenrede.",
    u: "50-mal im NT verwendet. Die Gabe der Zungenrede.",
    e: "Primäre Wurzel"
  },
  "G2041": {
    m: "Werk, Arbeit, Tat",
    d: "Arbeit, Mühe; Handlung, Tat; vollbrachtes Werk.",
    u: "169-mal im NT verwendet. Die Werke Gottes, die guten Werke.",
    e: "Von ἔργω (ergo) = arbeiten"
  },
  "G3793": {
    m: "Menge, Volksmenge",
    d: "Menschenmenge, Volksmenge; die Masse des Volkes.",
    u: "175-mal im NT verwendet. Die Menschenmengen, die Jesus folgten.",
    e: "Von ὄχος (ochos) = Fahrzeug (das trägt)"
  },
  "G1484": {
    m: "Nation, Volk, Heiden",
    d: "Volk, Nation; die heidnischen Nationen (Nicht-Juden).",
    u: "162-mal im NT verwendet. Das Evangelium für alle Nationen.",
    e: "Primäre Wurzel"
  },
  "G5443": {
    m: "Stamm, Volk",
    d: "Stamm, Sippe; ein Volk, das von einem gemeinsamen Vorfahren abstammt.",
    u: "31-mal im NT verwendet. Die zwölf Stämme Israels.",
    e: "Von φύω (phuo) = hervorbringen, wachsen lassen"
  },
  "G2992": {
    m: "Volk",
    d: "Ein Volk, eine Nation; besonders das Volk Gottes (Israel oder die Kirche).",
    u: "142-mal im NT verwendet. Das erwählte Volk Gottes.",
    e: "Primäre Wurzel"
  },
  "G2362": {
    m: "Thron",
    d: "Königssitz, Thron; königliche Macht und Autorität.",
    u: "62-mal im NT verwendet. Der Thron Gottes und des Lammes.",
    e: "Primäre Wurzel"
  },
  "G721": {
    m: "Lamm",
    d: "Kleines Lamm; bezeichnet Jesus Christus als das Lamm Gottes.",
    u: "30-mal im NT verwendet, hauptsächlich in der Offenbarung.",
    e: "Verkleinerungsform von ἀρήν (aren) = Lamm"
  },
  "G3022": {
    m: "weiß, strahlend",
    d: "Weiß, leuchtend; Symbol für Reinheit und Sieg.",
    u: "25-mal im NT verwendet. Die weißen Gewänder der Erlösten.",
    e: "Von λευκός (leukos) = weiß, leuchtend"
  },
  "G5495": {
    m: "Hand",
    d: "Die Hand; Macht, Autorität; Handlung, Werk.",
    u: "177-mal im NT verwendet. Die Hand Gottes, die Hände Jesu.",
    e: "Primäre Wurzel"
  },
  "G2424": {
    m: "Jesus",
    d: "Jesus von Nazareth, der Messias, der Erlöser.",
    u: "917-mal im NT verwendet. Der Name über allen Namen.",
    e: "Vom hebräischen יְהוֹשֻׁעַ (Jeschua) = JHWH rettet"
  },
  "G5547": {
    m: "Christus, Messias, der Gesalbte",
    d: "Der Gesalbte, der Messias; Titel Jesu als verheißener Erlöser.",
    u: "529-mal im NT verwendet. Jesus ist der Christus.",
    e: "Von χρίω (chrio) = salben"
  },
  "G907": {
    m: "taufen, eintauchen",
    d: "Ins Wasser eintauchen; zur Reinigung oder Initiation taufen.",
    u: "77-mal im NT verwendet. Die christliche Taufe.",
    e: "Von βάπτω (bapto) = eintauchen, untertauchen"
  },
  "G1746": {
    m: "anziehen, bekleiden",
    d: "Ein Kleid anziehen; sich mit einer Eigenschaft oder Macht bekleiden.",
    u: "27-mal im NT verwendet. Christus anziehen, die Waffenrüstung Gottes anziehen.",
    e: "Von ἐν (en) = in + δύω (duo) = eintreten, anziehen"
  },
  "G2453": {
    m: "Jude, jüdisch",
    d: "Zur jüdischen Rasse gehörend; Bewohner Judäas.",
    u: "195-mal im NT verwendet. Die Juden, erwähltes Volk Gottes.",
    e: "Von Ἰούδας (Ioudas) = Juda"
  },
  "G1672": {
    m: "Grieche, Heide",
    d: "Ein Grieche nach Geburt oder Sprache; ein Nicht-Jude.",
    u: "25-mal im NT verwendet. Weder Jude noch Grieche in Christus.",
    e: "Von Ἑλλάς (Hellas) = Griechenland"
  },
  "G1401": {
    m: "Sklave, Diener",
    d: "Sklave, Diener; freiwilliger Diener Gottes.",
    u: "124-mal im NT verwendet. Diener Christi.",
    e: "Von δέω (deo) = binden"
  },
  "G1658": {
    m: "frei, befreit",
    d: "Frei, kein Sklave; befreit von der Sklaverei der Sünde.",
    u: "23-mal im NT verwendet. Frei in Christus.",
    e: "Wahrscheinlich von ἔρχομαι (erchomai) = kommen"
  },
  "G730": {
    m: "männlich, Mann",
    d: "Männlichen Geschlechts, männlich.",
    u: "9-mal im NT verwendet. Gott schuf den Menschen männlich und weiblich.",
    e: "Primäre Wurzel"
  },
  "G2338": {
    m: "weiblich, Frau",
    d: "Weiblichen Geschlechts, weiblich.",
    u: "5-mal im NT verwendet. Mann und Frau gleich in Christus.",
    e: "Von θηλάζω (thelazo) = stillen"
  },
  "G1417": {
    m: "zwei",
    d: "Die Zahl zwei; ein Paar.",
    u: "135-mal im NT verwendet. Zwei oder drei Zeugen.",
    e: "Primäre Wurzel"
  },
  "G5109": {
    m: "Mauer, Wand",
    d: "Trennmauer, Scheidewand; physische oder symbolische Barriere zwischen Menschen oder Gruppen.",
    u: "1-mal im NT verwendet (Apg 23:3). 'Übertünchte Mauer' als Metapher für Heuchelei.",
    e: "Primäre Wurzel, verwandt mit τεῖχος (teichos) = Stadtmauer"
  },
  "G3320": {
    m: "Trennwand",
    d: "Mittelwand, Trennwand.",
    u: "1-mal im NT verwendet (Eph 2:14). Die Mauer zwischen Juden und Heiden.",
    e: "Von μέσος (mesos) = Mitte + τοῖχος (toichos) = Mauer"
  },
  "G2189": {
    m: "Feindschaft, Feindseligkeit",
    d: "Hass, Feindseligkeit, Feindschaft.",
    u: "6-mal im NT verwendet. Die Feindschaft gegen Gott wurde abgeschafft.",
    e: "Von ἐχθρός (echthros) = Feind"
  },
  "H7225": {
    m: "Anfang, Erstlinge",
    d: "Anfang, Beginn; das Beste, die Erstlinge.",
    u: "51-mal im AT verwendet. 'Am Anfang schuf Gott...'",
    e: "Von רֹאשׁ (rosch) = Kopf, Anfang"
  },
  "H7462": {
    m: "weiden, hüten, nähren",
    d: "Eine Herde weiden lassen; Hirte sein; nähren, pflegen.",
    u: "173-mal im AT verwendet. Der HERR ist mein Hirte.",
    e: "Primäre Wurzel"
  },
  "H2637": {
    m: "mangeln, brauchen",
    d: "Mangel haben, brauchen; abnehmen, fehlen.",
    u: "23-mal im AT verwendet. Mir wird nichts mangeln (Ps 23:1).",
    e: "Primäre Wurzel"
  },
  "H5216": {
    m: "Weide, bebautes Land",
    d: "Wiese, Weide; bebautes Land, Feld.",
    u: "2-mal im AT verwendet. Grüne Weiden.",
    e: "Von נִיר (nir) = pflügen"
  },
  "H216": {
    m: "Licht",
    d: "Natürliches oder geistliches Licht; Glück, Wohlstand.",
    u: "120-mal im AT verwendet. 'Es werde Licht!'",
    e: "Von אוֹר (or) = leuchten"
  },
  "H982": {
    m: "vertrauen, Vertrauen haben",
    d: "Vertrauen, Vertrauen haben; in Sicherheit sein.",
    u: "120-mal im AT verwendet. Vertrauen auf den HERRN.",
    e: "Primäre Wurzel"
  },
  "H3820": {
    m: "Herz, Geist",
    d: "Herz, Sitz der Emotionen; Geist, Verstand, Wille.",
    u: "598-mal im AT verwendet. Das Herz des Menschen.",
    e: "Primäre Wurzel"
  },
  "H3068": {
    m: "JHWH, der HERR",
    d: "Der Eigenname Gottes, heiliges Tetragramm JHWH.",
    u: "6828-mal im AT verwendet. Der heiligste Name.",
    e: "Von הָיָה (hajah) = sein, existieren"
  },
  "H160": {
    m: "Liebe, Zuneigung",
    d: "Liebe, Zuneigung; Liebestat.",
    u: "40-mal im AT verwendet. Die Liebe Gottes zu seinem Volk.",
    e: "Von אָהַב (ahab) = lieben"
  },
  "H5769": {
    m: "Ewigkeit, ewig",
    d: "Unbestimmte Zeit, Ewigkeit; immer, Beständigkeit.",
    u: "439-mal im AT verwendet. Die ewige Liebe Gottes.",
    e: "Von עָלַם (alam) = verbergen, verborgen sein"
  },
  "H2617": {
    m: "Güte, Barmherzigkeit, Treue",
    d: "Güte, Barmherzigkeit; Bundestreue; beständige Liebe.",
    u: "248-mal im AT verwendet. Die Güte des HERRN.",
    e: "Von חָסַד (chasad) = gütig sein, barmherzig sein"
  },
  "G32": {
    m: "Engel, Bote",
    d: "Bote; himmlischer Engel im Dienst Gottes.",
    u: "175-mal im NT verwendet. Die Engel Gottes.",
    e: "Von ἀγγέλλω (aggello) = ankündigen"
  },
  "G3735": {
    m: "Berg, Hügel",
    d: "Berg, Berg; hoher Hügel.",
    u: "63-mal im NT verwendet. Der Berg der Verklärung.",
    e: "Wahrscheinlich von ὁράω (horao) = sehen"
  },
  "G2222": {
    m: "Leben",
    d: "Physisches oder geistliches Leben; das ewige Leben in Gott.",
    u: "135-mal im NT verwendet. Jesus ist das Leben.",
    e: "Von ζάω (zao) = leben"
  },
  "G649": {
    m: "senden, delegieren",
    d: "Mit einer Mission senden; als Botschafter delegieren.",
    u: "132-mal im NT verwendet. Der Vater sendet den Sohn.",
    e: "Von ἀπό (apo) = von + στέλλω (stello) = senden"
  },
  "G2919": {
    m: "richten, entscheiden",
    d: "Richten, ein Urteil fällen; entscheiden, bestimmen.",
    u: "114-mal im NT verwendet. Gott richtet die Welt.",
    e: "Primäre Wurzel"
  },
  "G4982": {
    m: "retten, befreien",
    d: "Vor Gefahr oder Zerstörung retten; von Sünde befreien.",
    u: "106-mal im NT verwendet. Jesus rettet Sünder.",
    e: "Von σῶς (sos) = sicher und gesund"
  },
  "G3686": {
    m: "Name",
    d: "Name, Titel; Ruf; Autorität, Macht.",
    u: "228-mal im NT verwendet. Der Name Jesu.",
    e: "Primäre Wurzel"
  },
  "G3439": {
    m: "einzig, eingeboren",
    d: "Einzigartig in seiner Art, eingeboren; einziger Sohn.",
    u: "9-mal im NT verwendet. Der eingeborene Sohn Gottes.",
    e: "Von μόνος (monos) = allein + γίνομαι (ginomai) = werden"
  },
  "G622": {
    m: "verlieren, zerstören, zugrunde gehen",
    d: "Vollständig zerstören; verlieren, zugrunde gehen; ruiniert werden.",
    u: "90-mal im NT verwendet. Retten, was verloren war.",
    e: "Von ἀπό (apo) = von + ὄλλυμι (ollumi) = zerstören"
  },
  "H430": {
    m: "Gott, Götter",
    d: "Der höchste Gott (Elohim); manchmal für Richter oder heidnische Götter verwendet.",
    u: "2606-mal im AT verwendet. Pluralischer Majestätsname für Gott.",
    e: "Plural von אֱלוֹהַּ (eloah) = Gott"
  },
  "H1254": {
    m: "erschaffen",
    d: "Aus dem Nichts erschaffen; formen, machen; ausschließliche Tätigkeit Gottes.",
    u: "54-mal im AT verwendet. Gott schuf die Himmel und die Erde.",
    e: "Primäre Wurzel"
  },
  "H776": {
    m: "Erde, Land",
    d: "Erde, Boden; Land, Region; die irdische Welt.",
    u: "2504-mal im AT verwendet. Die Erde, die Gott schuf.",
    e: "Primäre Wurzel"
  },
  "H8414": {
    m: "formlos, leer, Chaos",
    d: "Wüste, Verwüstung; Chaos, Leere, Nichts.",
    u: "20-mal im AT verwendet. Die Erde war wüst und leer.",
    e: "Von תָּהָה (tahah) = umherirren"
  },
  "H7307": {
    m: "Geist, Atem, Wind",
    d: "Atem, Wind; Geist Gottes oder des Menschen; geistige Veranlagung.",
    u: "378-mal im AT verwendet. Der Geist Gottes.",
    e: "Von רוּחַ (ruach) = wehen"
  },
  "H559": {
    m: "sagen, sprechen",
    d: "Sagen, sprechen, erklären; befehlen, denken.",
    u: "5316-mal im AT verwendet. Das häufigste Verb des Sprechens.",
    e: "Primäre Wurzel"
  },
  "H7200": {
    m: "sehen, schauen",
    d: "Mit den Augen sehen; wahrnehmen, verstehen; vorsehen.",
    u: "1311-mal im AT verwendet. Gott sah, dass es gut war.",
    e: "Primäre Wurzel"
  },
  "H2896": {
    m: "gut, wohl",
    d: "Gut, angenehm, ausgezeichnet; wohlwollend, gerecht.",
    u: "559-mal im AT verwendet. Gott sah, dass es gut war.",
    e: "Primäre Wurzel"
  },
  "H7121": {
    m: "rufen, schreien, verkünden",
    d: "Rufen, schreien; benennen; verkünden, zusammenrufen.",
    u: "736-mal im AT verwendet. Den Namen des HERRN anrufen.",
    e: "Primäre Wurzel"
  },
  "H3117": {
    m: "Tag",
    d: "Tag (Gegenteil von Nacht); 24-Stunden-Zeitraum; Epoche, Zeit.",
    u: "2301-mal im AT verwendet. Der Tag, den der HERR gemacht hat.",
    e: "Von יוֹם (jom) = heiß sein"
  },
  "H3915": {
    m: "Nacht",
    d: "Nacht (Gegenteil von Tag); Zeit der Dunkelheit.",
    u: "234-mal im AT verwendet. Gott trennte Tag und Nacht.",
    e: "Primäre Wurzel"
  },
  "G2531": {
    m: "wie, gemäß",
    d: "Wie, auf die gleiche Weise; gemäß, insofern.",
    u: "182-mal im NT verwendet. Vergleichende Konjunktion.",
    e: "Von κατά (kata) = gemäß + ὡς (hos) = wie"
  },
  "G3475": {
    m: "Mose",
    d: "Mose, der Gesetzgeber Israels.",
    u: "80-mal im NT verwendet. Das Gesetz des Mose.",
    e: "Vom hebräischen מֹשֶׁה (Mosche) = herausgezogen (aus dem Wasser)"
  },
  "G5312": {
    m: "erhöhen, emporheben",
    d: "Hoch erheben, erhöhen; verherrlichen, ehren.",
    u: "20-mal im NT verwendet. Der Menschensohn erhöht.",
    e: "Von ὕψος (hupsos) = Höhe"
  },
  "G3789": {
    m: "Schlange",
    d: "Schlange, Reptil; die alte Schlange (Satan).",
    u: "14-mal im NT verwendet. Die eherne Schlange in der Wüste.",
    e: "Primäre Wurzel"
  },
  "G2048": {
    m: "Wüste, einsam",
    d: "Verlassener Ort, Wildnis; einsam, entvölkert.",
    u: "48-mal im NT verwendet. Die 40 Tage Jesu in der Wüste.",
    e: "Von ἔρημος (eremos) = verlassen"
  },
  "G3956": {
    m: "alle, jeder",
    d: "Alle, jeder, alle; das Ganze, die Gesamtheit.",
    u: "1244-mal im NT verwendet. Unter den häufigsten Wörtern.",
    e: "Primäre Wurzel"
  },
  "G4100": {
    m: "glauben, Glauben haben",
    d: "Glauben haben an, glauben; vertrauen auf, sich verlassen auf.",
    u: "241-mal im NT verwendet. An Jesus glauben, um gerettet zu werden.",
    e: "Von πίστις (pistis) = Glaube"
  },
  "H7549": {
    m: "Ausdehnung, Firmament",
    d: "Ausdehnung, Himmelsgewölbe, Firmament; der Himmel.",
    u: "17-mal im AT verwendet. Die Ausdehnung inmitten der Wasser.",
    e: "Von רָקַע (raqa) = ausdehnen, schlagen"
  },
  "H4325": {
    m: "Wasser, Gewässer",
    d: "Wasser, Gewässer; Regen; Flut, Meer.",
    u: "585-mal im AT verwendet. Die Wasser der Schöpfung.",
    e: "Dual von מַיִם (majim) = Wasser"
  },
  "H6213": {
    m: "tun, vollbringen",
    d: "Tun, machen, vollbringen; handeln, arbeiten.",
    u: "2632-mal im AT verwendet. Sehr häufiges Verb.",
    e: "Primäre Wurzel"
  },
  "H8064": {
    m: "Himmel",
    d: "Himmel, Firmament; Wohnung Gottes; sichtbarer Himmel.",
    u: "420-mal im AT verwendet. Die Himmel und die Erde.",
    e: "Dual von שָׁמַיִם (schamaim) = Höhen"
  },
  "H120": {
    m: "Mensch, Menschheit, Adam",
    d: "Mensch, menschliches Wesen; die Menschheit; Adam der erste Mensch.",
    u: "562-mal im AT verwendet. Gott schuf den Menschen.",
    e: "Von אָדֹם (adom) = rot, oder אֲדָמָה (adamah) = Erde"
  },
  "H6754": {
    m: "Bild, Gleichnis",
    d: "Bild, Gleichnis; Form, Erscheinung.",
    u: "17-mal im AT verwendet. Der Mensch nach dem Bild Gottes geschaffen.",
    e: "Von צָלַל (tsalal) = beschatten, gleichen"
  },
  "H3966": {
    m: "sehr, äußerst",
    d: "Sehr, äußerst, viel; mit Kraft, schnell.",
    u: "300-mal im AT verwendet. Es war sehr gut.",
    e: "Von מָאַד (ma'ad) = zahlreich sein"
  },
  "H7257": {
    m: "sich legen, ruhen",
    d: "Sich legen, ruhen; verweilen; brüten.",
    u: "30-mal im AT verwendet. Er lässt mich lagern (Ps 23:2).",
    e: "Primäre Wurzel"
  },
  "H4999": {
    m: "Weide, Wohnung",
    d: "Weideplatz, Wiese; Wohnung, Aufenthalt.",
    u: "13-mal im AT verwendet. Auf grünen Auen.",
    e: "Von נָאָה (na'ah) = schön sein, geeignet sein"
  },
  "H5148": {
    m: "führen, leiten",
    d: "Führen, leiten, lenken; sicher führen.",
    u: "40-mal im AT verwendet. Er führt mich (Ps 23:3).",
    e: "Primäre Wurzel"
  },
  "H7725": {
    m: "zurückkehren, wiederherstellen",
    d: "Zurückkehren, wiederkommen; wiederherstellen, erneuern; umkehren.",
    u: "1058-mal im AT verwendet. Meine Seele erquicken.",
    e: "Primäre Wurzel"
  },
  "H5315": {
    m: "Seele, Leben, Person",
    d: "Seele, Leben, Lebewesen; Person, Selbst; Verlangen, Appetit.",
    u: "753-mal im AT verwendet. Meine Seele, mein Leben.",
    e: "Von נָפַשׁ (napasch) = atmen"
  },
  "H6664": {
    m: "Gerechtigkeit, Rechtschaffenheit",
    d: "Gerechtigkeit, Rechtschaffenheit, Billigkeit; Treue.",
    u: "119-mal im AT verwendet. Pfade der Gerechtigkeit.",
    e: "Von צָדַק (tsadaq) = gerecht sein"
  },
  "H1980": {
    m: "gehen, wandeln",
    d: "Gehen, wandeln, kommen; leben, sich verhalten.",
    u: "1554-mal im AT verwendet. Sehr häufiges Bewegungsverb.",
    e: "Primäre Wurzel"
  },
  "H1516": {
    m: "Tal, Schlucht",
    d: "Tal, Schlucht, Klamm; Ebene.",
    u: "60-mal im AT verwendet. Das Tal des Todesschattens.",
    e: "Primäre Wurzel"
  },
  "H6757": {
    m: "Todesschatten, tiefe Finsternis",
    d: "Tiefe Finsternis, tödliche Dunkelheit; Schatten des Todes.",
    u: "18-mal im AT verwendet. Symbolisiert extreme Gefahr.",
    e: "Von צֵל (tsel) = Schatten + מָוֶת (maweth) = Tod"
  },
  "H3372": {
    m: "fürchten, Ehrfurcht haben",
    d: "Fürchten, Angst haben; Gott verehren, respektieren.",
    u: "335-mal im AT verwendet. Ich fürchte kein Unheil.",
    e: "Primäre Wurzel"
  },
  "H7626": {
    m: "Stab, Stamm",
    d: "Stab, Rute; Stamm, Familienzweig.",
    u: "190-mal im AT verwendet. Dein Stecken und Stab.",
    e: "Von שָׁבַט (schawat) = verzweigen"
  },
  "H1004": {
    m: "Haus, Wohnung",
    d: "Haus, Wohnung; Familie, Haushalt; Tempel.",
    u: "2055-mal im AT verwendet. Das Haus des HERRN.",
    e: "Von בָּנָה (banah) = bauen"
  },
  "H6186": {
    m: "ordnen, aufstellen",
    d: "In Ordnung bringen, aufstellen; einen Tisch bereiten.",
    u: "75-mal im AT verwendet. Du richtest einen Tisch an (Ps 23:5).",
    e: "Primäre Wurzel"
  },
  "H7979": {
    m: "Tisch",
    d: "Esstisch; Tisch der Schaubrote.",
    u: "71-mal im AT verwendet. Der bereitete Tisch.",
    e: "Von שָׁלַח (schalach) = senden, ausstrecken"
  },
  "H6887": {
    m: "bedrängen, Widersacher",
    d: "Bedrängt sein, in Not sein; Widersacher, Feind.",
    u: "58-mal im AT verwendet. Angesichts meiner Feinde.",
    e: "Primäre Wurzel"
  },
  "H1878": {
    m: "fett machen, mästen",
    d: "Fett machen, mästen; gedeihen lassen.",
    u: "11-mal im AT verwendet. Du salbst mein Haupt mit Öl.",
    e: "Von דֶּשֶׁן (deschen) = Fett, Asche"
  },
  "H3563": {
    m: "Becher, Kelch",
    d: "Becher, Kelch; Anteil, Los.",
    u: "31-mal im AT verwendet. Mein Becher fließt über.",
    e: "Primäre Wurzel"
  },
  "H7291": {
    m: "verfolgen, jagen",
    d: "Verfolgen, jagen; verfolgen; dicht folgen.",
    u: "144-mal im AT verwendet. Güte wird mir folgen.",
    e: "Primäre Wurzel"
  }
};
